import {
    DOCUMENT_REVISIONS_UPDATE,
    DOCUMENT_REVISIONS_SET_LOADING,
    DOCUMENT_REVISIONS_ERROR,
    DOCUMENT_REVISION_CREATED,
    DOCUMENT_LAST_REVISIONS_UPDATE, DOCUMENT_LAST_REVISIONS_SET_LOADING,
} from '../actions/documentRevisionsActions';

const INITIAL_STATE = {
    lastRevision: null,
    revisions: [],
    pagination: null,
    loading: false,
    error: null,
    revisionCreatedId: null,
    rntInfo: null,
    lastRevisionLoading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DOCUMENT_REVISIONS_UPDATE:
            return {
                ...state,
                revisions: action.payload.data,
                pagination: action.payload.pagination,
                error: action.payload.message
            };
        case DOCUMENT_REVISIONS_ERROR:
            return { ...state, error: action.payload };
        case DOCUMENT_REVISIONS_SET_LOADING:
            return { ...state, loading: action.payload };
        case DOCUMENT_REVISION_CREATED:
            return { ...state, revisionCreatedId: action.payload, rntInfo: action.rntInfo };
        case DOCUMENT_LAST_REVISIONS_UPDATE:
            let revision = null;
            const revisions = action.payload.data;
            if (revisions && revisions.length !== 0) {
                revision = revisions[0];
            }
            return {...state, lastRevision: revision};
        case DOCUMENT_LAST_REVISIONS_SET_LOADING:
            return { ...state, lastRevisionLoading: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/documents/reducers/DocumentRevisionsReducer.js